import { Environment } from './interface';
import { firebaseConfig } from './firebase/testing';

export const environment: Environment = {
  production: true,
  environment: 'test',
  apiUrl: 'https://backend.staging.fleetchaser.com/',
  cmsUrl: 'https://staging.fleetchaser.com/',
  apiDomain: 'backend.staging.fleetchaser.com',
  eventSourceHost: 'https://live.staging.fleetchaser.com',
  googleMapsApiKey: 'AIzaSyC_a4dpHDuElp5lZC-vpq7pDqYvKjsvIGM',
  amplitudeApiKey: 'dadc91607609b440163b3ff9da72fbb2',
  sentry: 'https://847fea33d2f440d397bb19641f5f8fea@sentry.io/269708',
  filesApi: 'https://files.staging.fleetchaser.com',
  sentryEnvironment: 'test',
  googleAnalyticsApiKey: 'GTM-W625ZZMN',

  aeris: {
    id: 'JZsbuN8s8LiApFQzTrWrg',
    secret: 'yTNbERS9LlxJRZoufJcBh9dDVCCPgXUd2YQd08wB',
  },
  tigerService: 'https://tiger.fleetchaser.com/api/v1/tiger/',
  valhallaUrl: 'https://valhalla.fleetchaser.com',
  firebaseConfig: firebaseConfig,
  vapidKey:
    'BAnerMt-Qa6fG8vIu4HAJKz24sFA75tzxQTni-ziBPGcolM-R-4wvyNpTrmUVVw9EvHE-Orxuf5_6soogLYW0nQ',
  chatWsUrl: 'wss://chat.staging.fleetchaser.com/ws?token=',
  webrtcUrl: 'https://hgateway.staging.fleetchaser.com',
  tus: 'https://uploads.staging.fleetchaser.com/files/',
};
